import Input from "../../components/Input/Input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import schema from "../../utils/validations/SignUp/index";

import { SIGNUP } from "../../data/Sign";
import Button from "../../components/Button/Button";

import { NavLink } from "react-router";

import styles from "../../shared-styles/Sign.module.css";

import { FaGoogle } from "react-icons/fa";
import { IconBaseProps } from "react-icons";
import { FunctionComponent } from "react";
import { toast } from "react-toastify";

import { useNavigate } from "react-router";

import { InputNameSignUp, InputTypeSignUp } from "../../types/index";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";

import { signUp as signUpDispatch } from "../../store/auth/signUpThunk";
import { signUpWithGoogle as signUpWithGoogleDispatch } from "../../store/auth/Google/signUpWithGoogleThunk";

interface SubmitForm {
  fullName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export default function SignUp() {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const { signUpLoading } = useSelector(
    (state: RootState) => state.auth.signUp
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isLoading, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema)
  });

  async function onSubmit(data: SubmitForm) {
    const resultAction = await dispatch(
      signUpDispatch({
        email: data.email,
        password: data.password,
        fullName: data.fullName
      })
    );

    if (signUpDispatch.rejected.match(resultAction)) {
      toast.error(resultAction.payload?.message || "Something went wrong");
    } else {
      toast.success("Sign Up successful");
      const cleanTime = setTimeout(() => {
        clearTimeout(cleanTime);
        navigate("/");
      }, 500);
    }
  }

  async function handleGoogleSignUp() {
    const resultAction = await dispatch(signUpWithGoogleDispatch());
    if (signUpWithGoogleDispatch.rejected.match(resultAction)) {
      toast.error(resultAction.payload?.message || "Something went wrong");
    } else {
      toast.success("Sign Up successful");
      const cleanTime = setTimeout(() => {
        clearTimeout(cleanTime);
        navigate("/");
      }, 500);
    }
  }

  return (
    <main className={styles.main}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <h1>SignUp</h1>
        <div className={styles.box}>
          {SIGNUP.map((input) => (
            <Input<InputNameSignUp, InputTypeSignUp>
              key={input.name}
              {...input}
              {...register(input.name)}
              errorMessage={errors[input.name]?.message}
            />
          ))}

          <div className={styles.buttonsActions}>
            <Button
              type="submit"
              className="primary"
              disabled={isLoading || isSubmitting || signUpLoading}
            >
              {isLoading || isSubmitting || signUpLoading
                ? "Sign up ..."
                : "Sign up"}
            </Button>
            <Button
              type="button"
              className="google"
              disabled={isLoading || isSubmitting || signUpLoading}
              onClick={handleGoogleSignUp}
              icon={FaGoogle as FunctionComponent<IconBaseProps>}
            >
              {isLoading || isSubmitting || signUpLoading
                ? "Sign up ..."
                : "Sign up with Google"}
            </Button>
            <p className={styles.navigation}>
              Already have an account? <NavLink to="/sign-in">SignIn</NavLink>
            </p>
          </div>
        </div>
      </form>
    </main>
  );
}
